import { createUseStyles } from 'react-jss'
import { zIndexes } from '../../variables.style'

export const style = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    fontSize: 18,
    zIndex: zIndexes.chartLoader
  },
  chartContainer: {
    position: 'relative'
  },
  chartLoaderWithData: {
    extend: 'container',
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: '100%'
  }
}

export const useStyles = createUseStyles(style)
